export const LayoutNames = {
  lg: 'Desktop',
  md: 'Laptop',
  sml: 'Tablet (L)',
  sm: 'Tablet (S)',
  xs: 'Mobile (L)',
  ss: 'Mobile (S)',
}
